import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import DataProvider from "./context/DataProvider";
import { ThemeProvider } from "./theme/ThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <DataProvider>
          <ScrollToTop />
          <App />
        </DataProvider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
